// extracted by mini-css-extract-plugin
export default {"bio":"AboutUs_bio__Br1Mf","bio_item":"AboutUs_bio_item__2eqnx","image_logo":"AboutUs_image_logo__mQd9Y"};